import React from 'react';
import PropTypes from 'prop-types';

/**
 * @param {{ adminName: string, subscriptionType: string }} props
 */
const HeroSection = ({ adminName, subscriptionType }) => {
  return (
    <section className="relative overflow-hidden py-8 md:py-9 md:min-h-[420px]">
      <img
        src="/public/images/roster-background.png"
        alt="roster-background"
        className="absolute inset-0 h-full w-full object-cover"
      />

      <div className="relative flex flex-col items-center text-center md:justify-center md:h-full gap-1">
        <h1 className="text-2xl md:text-4xl font-bold text-white leading-[36px] md:leading-[52px]">
          Create Your Roster
        </h1>
        <p className="text-teal-10 md:text-base font-bold leading-6">
          {adminName}{' '}
          <span className="hidden md:inline">&nbsp;&nbsp;•&nbsp;&nbsp;</span>
          <br className="md:hidden" /> {subscriptionType}
        </p>
      </div>
    </section>
  );
};

HeroSection.propTypes = {
  adminName: PropTypes.string,
  subscriptionType: PropTypes.string,
};

HeroSection.defaultProps = {
  adminName: "Admin's Name",
  subscriptionType: 'Elevated Profile Subscription',
};

export default HeroSection;
